
import { React, useEffect, useState } from "react";
import Navbar from "./components/Navbar/Navbar";
import Home from "./pages/Home/Home";
import { Routes, Route, BrowserRouter, useLocation } from "react-router-dom";
import Careers from "./pages/Carrier/Careers";
import MHcv from "./pages/Products/M&HCV_Tippers/M&Hcv.jsx";
import Footer from "./components/Footer/Footer.jsx";
import Enqiry from "./pages/Enqiry/Enqiry.jsx";
import Aboutus from "./pages/About/Aboutus.jsx";
import 'leaflet/dist/leaflet.css';
import GangavathiWf from "./pages/Enqiry/Gangavathi_wf.jsx";
import DanapurWf from "./pages/Enqiry/DanapurWf.jsx";
import KurekuppaWf from "./pages/Enqiry/KurekuppaWf.jsx";
import RaichurWf from "./pages/Enqiry/RaichurWf.jsx";
import BallariWf from "./pages/Enqiry/BallariWf.jsx";
import LoadingScreen from "./pages/Home/LoadingScreen.jsx";
import PrivacyPolicy from "./components/PrivacyPolicy.jsx";
import TermsAndConditions from "./components/TermsConditions.jsx";
import JAW_RANE from './pages/About/JAW_RANE.jsx';
import JAW_TELTURBO from "./pages/About/JAW_TELTURBO.jsx";
import JAW_WABCO from "./pages/About/JAW_WABCO.jsx";
import JAW_TATABATTERIES from "./pages/About/JAW_TATABATTERIES.jsx";
import JAW_CUMMINS from "./pages/About/JAW_CUMMINS.jsx";
import JAW_ENG_REC from "./pages/About/JAW_ENG_REC.jsx";
import JAW_MINING from "./pages/About/JAW_MINING.jsx";
import IQRA_SCHOOL from "./pages/About/IQRA_School.jsx";
import BlogPage from "./pages/Blogs.jsx";
import ScrollToTop from "./components/Scrolltotop.jsx";
import Adminapp from './Admin/Adminapp.jsx';

// New component to handle conditional rendering
const AppContent = () => {
  const location = useLocation();

  // Define the paths where the footer should be hidden.
  // Add any new 'About Us' pages to this array.
  const noFooterPaths = [
    "/about",
    "/jaw-rane",
    "/jaw-telturbo",
    "/jaw-wabco",
    "/jaw-tata-batteries",
    "/jaw-cummins",
    "/jaw-eng-recondition",
    "/jaw-mining-operations",
    "/jaw-iqra-school",
    "/admin",

  ];

  // const showFooter = !noFooterPaths.includes(location.pathname);

   // Hide footer for these paths OR if path starts with /admin
  const showFooter = !(
    noFooterPaths.includes(location.pathname) ||
    location.pathname.startsWith('/admin')
  );

  // Similarly, hide Navbar when in admin
  const showNavbar = !location.pathname.startsWith('/admin');

  return (
    <>
       {showNavbar && <Navbar />}
      <Routes>
        <Route path="/" element={<Home />} />
        <Route path="/career" element={<Careers />} />
        {/* <Route path="/mhcv" element={<MHcv />} /> */}
        <Route path="/mhcv/*" element={<MHcv />} />
        <Route path="/blogs/*" element={<BlogPage/>} />

        {/* Service Booking Forms */}
        <Route path="/enqiry" element={<Enqiry />} />
        <Route path="/gangavathi" element={<GangavathiWf />} />
        <Route path="/danapurwf" element={<DanapurWf />} />
        <Route path="/kurekuppawf" element={<KurekuppaWf />} />
        <Route path="/raichurwf" element={<RaichurWf />} />
        <Route path="/ballariwf" element={<BallariWf />} />
        <Route path="/about" element={<Aboutus />} />
        {/* new multi */}

        {/* images link */}
        <Route path="/mhcv" element={<MHcv />} />
        {/* <Route path="/mhcv" element={<MHcv />} />
        <Route path="/mhcv" element={<MHcv />} />
        <Route path="/mhcv" element={<MHcv />} /> */}
        {/* homepage to about page */}
        <Route path="/about" element={<Aboutus />} />
        <Route path="/jaw-rane" element={<JAW_RANE/>} />
        <Route path="/jaw-telturbo" element={<JAW_TELTURBO/>} />
        <Route path="/jaw-wabco" element={<JAW_WABCO/>} />
        <Route path="/jaw-tata-batteries" element={<JAW_TATABATTERIES/>} />
        <Route path="/jaw-cummins" element={<JAW_CUMMINS/>} />
        <Route path="/jaw-eng-recondition" element={<JAW_ENG_REC/>} />
        <Route path="/jaw-mining-operations" element={<JAW_MINING/>} />
        <Route path="/jaw-iqra-school" element={<IQRA_SCHOOL/>} />
        <Route path="/privacy" element={<PrivacyPolicy />} />
        <Route path="/terms" element={<TermsAndConditions />} />

          {/* Admin routes under /admin/* */}
        <Route path="/admin/*" element={<Adminapp/>} />
      </Routes>
      {/* Conditionally render the Footer based on the current path */}
      {showFooter && <Footer />}
    </>
  )
}

const App = () => {
  // Global loading state
  const [isLoading, setIsLoading] = useState(true);

  // Set the loading state when the app is ready
  useEffect(() => {
    const timer = setTimeout(() => {
      setIsLoading(false);
    }, 1000); // Adjust the loading duration if needed
    return () => clearTimeout(timer); // Clean up timer on unmount
  }, []);

  return (
    <main>
      {/* Show LoadingScreen globally */}
      {isLoading ? (
        <LoadingScreen />
      ) : (
        <BrowserRouter>
        <ScrollToTop/>
          <AppContent />
        </BrowserRouter>
      )}
    </main>
  );
};

export default App;